import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
export function FinalCTA() {
  return <section className="border-t-4 border-safety bg-graphite px-3 py-4 text-center sm:px-6" data-id="element-50" data-mp="3udf8az5tp7i7">
      <div className="mx-auto max-w-xl" data-id="element-51" data-mp="c7tv9kju0su1">
        <h2 className="font-display text-[1.7rem] font-bold uppercase leading-none text-white sm:text-[2.3rem]" data-id="element-52" data-mp="c4o7c8mxvwzw">
          ONE LAST <span className="text-safety" data-id="element-53" data-mp="m4ouk5nxix9d">QUESTION</span>
        </h2>
        <p className="mt-1.5 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-54" data-mp="m33wi62eow6r">
          When you walk into a workplace filled with equipment, people, materials, storage,
          electrical systems, access routes and constantly changing conditions...
        </p>
        <p className="mt-1 font-display text-[1.2rem] font-bold uppercase leading-tight text-safety sm:text-[1.5rem]" data-id="element-55" data-mp="qwzsj2z408za">
          Do you know exactly what you should inspect, document and follow up on?
        </p>
        <p className="mt-1 text-[0.8rem] leading-[1.4] text-white/85 sm:text-[0.92rem]" data-id="element-56" data-mp="zy6dbo8sk5yc">
          Stop relying on memory, scattered checklists and disconnected reports to manage workplace
          safety inspections.
        </p>
        <p className="mt-1 text-[0.76rem] font-extrabold uppercase tracking-wide text-white sm:text-[0.9rem]" data-id="element-57" data-mp="2m2u9n49xfv6b">
          Prepare the inspection. Identify the hazard. Prioritize the risk. Document the finding.
          Verify the action.
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[250px] sm:max-w-[310px]" data-id="element-58" data-mp="2v2r5pqynbwbe" />

        <p className="mt-2 font-display text-[1.4rem] font-bold uppercase leading-none text-white sm:text-[1.9rem]" data-id="element-59" data-mp="301tzugd38i4l">
          🦺 SAFETY <span className="text-safety" data-id="element-60" data-mp="34tu60qjr479m">INSPECTION PRO™</span>
        </p>
        <p className="mt-1 text-[0.66rem] font-bold uppercase tracking-wide text-mist sm:text-[0.82rem]" data-id="element-61" data-mp="39somhlu8xjqk">
          THE COMPLETE WORKPLACE SAFETY INSPECTION SYSTEM
        </p>
        <p className="mt-0.5 text-[0.6rem] font-bold uppercase tracking-[0.08em] text-warning sm:text-[0.78rem]" data-id="element-62" data-mp="3istthuvj2g47">
          Prepare • Inspect • Identify • Prioritize • Document • Correct
        </p>

        <div className="mx-auto mt-2 max-w-md" data-id="element-63" data-mp="1epij3n2xvvhp">
          <p className="text-[0.8rem] font-black uppercase tracking-wide text-white sm:text-[0.95rem]" data-id="element-64" data-mp="1eqtmhlsh318a">
            🔥 GET THE COMPLETE SYSTEM TODAY
          </p>
          <div className="mt-1.5" data-id="element-65" data-mp="1npf2paah245w">
            <CTAButton label="🦺 GET SAFETY INSPECTION PRO™" data-id="element-66" data-mp="1nodpp09wb7lj" />
          </div>
          <p className="mt-2 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-67" data-mp="22drzualapt1z">
            Immediate Access • Digital Delivery
          </p>
          <p className="mt-0.5 text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-68" data-mp="2bf9c1hvl1ale">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}